/**
 * Collateral Assignment Transaction Type
 * tag: 903
 * @readonly
 * @enum {number} (int)
 */
export enum CollAsgnTransType {
  /** New */
  New = 0,
  /** Replace */
  Replace = 1,
  /** Cancel */
  Cancel = 2,
  /** Release */
  Release = 3,
  /** Reverse */
  Reverse = 4,
}
